module.exports = __webpack_public_path__ + "static/media/sequoia.52542550.jpg";